import { Inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { ICurrentUser } from '../../interfaces';
import { forkJoin, Observable, switchMap } from 'rxjs';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class HttpAuthenticationService implements HttpInterceptor {
    constructor(@Inject('ICurrentUser') public currentUser: ICurrentUser,) {
    }

    /* eslint-disable  @typescript-eslint/no-explicit-any */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return forkJoin({
            accessToken: this.currentUser.accessToken.pipe(token1=>{
                return token1;
            }),
            idToken: this.currentUser.idToken.pipe(token=>{
                return token;
            })
         }).pipe(
            switchMap(({accessToken, idToken}) => {
                const newToken = this.DecodeToken(accessToken);
                const modifiedRequest = request.clone({
                    setHeaders: {
                        Authorization : `Bearer ${newToken}`,
                        'id-token': `${idToken}`
                     }
                });
                return next.handle(modifiedRequest);
            })
         );
         
        // return this.currentUser.accessToken.pipe(
        //     mergeMap(token => {
        //         const newToken = this.DecodeToken(token);
        //         const modifiedRequest = request.clone({
        //             headers: request.headers.set('Authorization', `Bearer ${newToken}`)
        //         });

        //         return next.handle(modifiedRequest);
        //     })
        // );
    }

    DecodeToken(token: string)
    {
        let newToken = token;
        if(token)
        {
            const [headerB64, payloadB64, signature] = token.split('.');
            const header = JSON.parse(atob(headerB64));
            const plainNonce = header.nonce;

           const encodedNonce = this.updateToken(plainNonce);
           header.nonce = encodedNonce;
           

            const newHeaderB64 = btoa(JSON.stringify(header));
            newToken = `${newHeaderB64}.${payloadB64}.${signature}`;
        }
        return newToken;
    }

 

    updateToken(plainedNonce: string){
        const hashedNonce = CryptoJS.SHA256(plainedNonce).toString(CryptoJS.enc.Base64);
        const encodedNonce = this.encode(hashedNonce);
        return encodedNonce;
    }

    encode(input:string): string {
        let output = input;
        output = output.split('=')[0];
        output = output.replace(/\+/g, '-');
        output = output.replace(/\//g, '_');
        return output;
    }
}